var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AsiContentContainer',{attrs:{"no-margin":""}},[_c('v-divider'),_c('UserList',{attrs:{"company":_vm.company}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }